import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import IntroAdmin from "./IntroAdmin";
import AboutAdmin from "./AboutAdmin";
import ExperienceAdmin from "./ExperienceAdmin";
import ProjectsAdmin from "./ProjectsAdmin";
import ContactAdmin from "./ContactAdmin";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("intro");
  const [admin, setAdmin] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const userData = localStorage.getItem("adminUser");

    if (!token) {
      navigate("/admin/login");
    } else {
      setAdmin(JSON.parse(userData));
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    navigate("/admin/login");
  };

  const tabs = [
    { id: "intro", label: "Intro", icon: "🏠" },
    { id: "about", label: "About", icon: "👤" },
    { id: "experience", label: "Experience", icon: "💼" },
    { id: "projects", label: "Projects", icon: "🚀" },
    { id: "contact", label: "Contact", icon: "📧" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-slate-950 to-black text-white">
      {/* Header */}
      <header className="border-b border-white/10 backdrop-blur-xl bg-black/30 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-0">
          <div>
            <h1 className="text-xl sm:text-2xl font-light">Admin Dashboard</h1>
            <p className="text-white/40 text-xs sm:text-sm">
              Welcome, {admin?.username}
            </p>
          </div>

          <div className="flex gap-2 sm:gap-4 items-center w-full sm:w-auto">
            <Link
              to="/"
              className="flex-1 sm:flex-none text-center px-3 sm:px-4 py-2 border border-white/20 rounded-lg hover:bg-white/10 transition-all text-xs sm:text-sm"
            >
              View Site
            </Link>
            <button
              onClick={handleLogout}
              className="flex-1 sm:flex-none px-3 sm:px-4 py-2 bg-red-500/20 border border-red-500/30 rounded-lg hover:bg-red-500/30 transition-all text-xs sm:text-sm"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {/* Navigation Tabs */}
        <div className="flex gap-2 mb-6 sm:mb-8 overflow-x-auto pb-2 scrollbar-hide">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl transition-all whitespace-nowrap text-sm sm:text-base ${
                activeTab === tab.id
                  ? "bg-white/10 border border-white/20 text-white"
                  : "bg-white/[0.02] border border-white/5 text-white/50 hover:bg-white/5"
              }`}
            >
              <span className="mr-1 sm:mr-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="bg-white/[0.02] border border-white/[0.08] backdrop-blur-xl rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
          {activeTab === "intro" && <IntroAdmin />}
          {activeTab === "about" && <AboutAdmin />}
          {activeTab === "experience" && <ExperienceAdmin />}
          {activeTab === "projects" && <ProjectsAdmin />}
          {activeTab === "contact" && <ContactAdmin />}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
